<template>
    <div class="OnlineTeacher">

        <div class="container-fluid grey-bg-line">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12">
                        <div class="breadcrumbs">
                            <a href="/">Главная</a> / Вступительные мини-экзамены в Полиглотиках
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-8 col-lg-10 order-lg-1 order-1">
                        <h1 class="exams-h1">Вступительные мини-экзамены в Полиглотиках</h1>
                    </div>
                    <div class="col-4 col-lg-2 order-lg-3 mt-lg-n6 order-2">
                        <div class="bird-teacher"></div>
                    </div>
                    <div class="col-12 col-lg-10  order-lg-2  order-3">
                        <p class="px18 mb-5">
                            <span class="strong-black">Пройти вступительное тестирование</span> – это как сдать анализ
                            крови. Чтобы начать лечение, сначала нужно поставить диагноз. Так и с английским языком:
                            чтобы изучать язык эффективно, необходимо определить первоначальный уровень владения
                            иностранным языком.
                        </p>
                    </div>

                </div>
            </div>
        </div>
        <div class="container-fluid bottom-shadow">
        </div>
        <div class="container-fluid">
            <div class="container align-middle">
                <div class="row">
                    <div class="col-12 bottom-shadow-triagle-wrapper">
                        <img class="bottom-shadow-triagle" src="@/assets/hometeacher/images/bg-gray-triagle.png">
                    </div>
                </div>
            </div>
        </div>


        <div class="container-fluid white-bg fr-page no-shadow">
            <div class="container align-middle">
                <div class="row mt-6">
                    <div class="col-12 col-lg-9">
                        <p class="px18">Для нас недостаточно просто определить языковой уровень, <span
                                class="strong-black">важно выявить пробелы в
                            знаниях</span>, чтобы впоследствии делать упор на то, что требует большего внимания.
                            Возможно, у
                            ребенка большой словарный запас, но при этом слабая грамматика. Или он отлично помнит фразы,
                            а использовать их в речи не может. </p>

                        <h2 class="exam-green-subhead">Научный подход</h2>
                        <p class="px18">Вы с ребенком приходите в наши центры за иностранными языками, а каков ваш
                            начальный уровень, каков ваш диагноз? <span class="strong-black">Наши мини-экзамены помогают определить не только
                            уровень знаний, но и подобрать оптимальный вариант занятий.</span><br>
                            Это могут быть как офлайн, так и онлайн курсы. А возможно, совмещение этих форматов занятий.
                            Что подойдет именно вашему ребенку: групповые или индивидуальные занятия? Два-три раза в
                            неделю или больше? Ответить на эти вопросы помогут наши педагоги после прохождения
                            тестирования.</p>
                    </div>
                    <div class="col-3 col-lg-3 d-lg-block d-none">
                        <img src="@/assets/hometeacher/images/test-monitor-image.png">
                    </div>
                    <div class="col-12 col-lg-12">

                        <h2 class="exam-green-subhead">К чему может привести игнорирование теста?</h2>
                        <p class="px18">Без прохождения тестирования сложно подобрать подходящую группу для офлайн
                            занятий или выбрать правильный видеокурс. В конечном итоге, вы можете признать методику
                            неподходящей для вашего ребенка, а ему было просто сложно обучаться именно в этой группе,
                            так как изначально был выбран неправильный курс. Или ребенку наоборот, было легко, так как
                            он занимался в группе с начинающими.<br>
                            Чтобы избежать этих ошибок, не обвинять методику или преподавателя, <span
                                    class="strong-black">надо просто пройти наш
                            тест.</span></p>
                        <p class="px18"></p>

                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-top: 50px; margin-bottom:10px;"></div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <h2 class="blueh2">Инструкция по прохождению тестирования</h2>

                        <p class="px18 exam-point"><span class="strong-blue">1.</span> Подготовьте рабочее место для
                            ребенка: настройте свет, расположите удобно компьютер, настройте звук.</p>
                        <p class="px18 exam-point"><span class="strong-blue">2.</span> Покажите ребенку, как
                            пользоваться мышкой, если он не умеет, или проходите тест вместе с ребенком, нажимая тот
                            вариант, на который указывает ребенок.</p>

                        <p class="px18 exam-notice"><span class="strong-red">Важно! </span> <span class="strong-black"> Не подводите ребенка к правильному ответу, не помогайте решать задания. Ваша задача – помогать с техническими моментами.</span>
                        </p>

                        <p class="px18 exam-point"><span class="strong-blue">3.</span> В соответствующей строке выберите
                            возраст ребенка</p>
                        <p class="px18 exam-point"><span class="strong-blue">4.</span> Тест состоит из 25-28 вопросов.
                            Правильный ответ засчитывается за верно выполненную карточку целиком (не за отдельный вопрос
                            в карточке).</p>
                        <p class="px18 exam-point"><span class="strong-blue">5.</span> Задания теста необходимо
                            выполнять последовательно.</p>
                        <p class="px18 exam-point"><span class="strong-blue">6.</span> После прохождения теста вы
                            увидите результат вашего ребенка.</p>
                        <p class="px18 exam-point"><span class="strong-blue">7.</span> Результаты тестирования будут
                            высланы на вашу почту и отражены в Личном кабинете.</p>
                        <p class="px18 exam-point"><span class="strong-blue">8.</span> Вместе с результатами будут даны
                            рекомендации.</p>
                        <p class="px18 exam-point"><span class="strong-blue">9.</span> При необходимости Вы можете
                            записаться на индивидуальную консультацию с нашим педагогом.</p>

                        <p class="px18"><span class="strong-black">Для нас важно узнать реальный уровень владения языком.</span>
                        </p>
                        <p class="px18 exam-res h4"><span class="strong-green">Помните, что любое измерение результатов улучшает эти результаты.</span>
                        </p>

                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="land-t-delimeter" style="margin-top: 30px;margin-bottom: 10px;"></div>
                    </div>
                </div>


                <div class="row">
                    <div class="col-12">
                        <h2 class="exam-list">Выберите тест:</h2>
                    </div>
                    <div class="col-12">
                        <exam-list-item v-for="(item, index) in exams"
                                        :key="index"
                                        :last-item="index === exams.length - 1"
                                        :exam="item"/>
                    </div>
                </div>

            </div>
        </div>


    </div>
</template>

<script>

    import ExamListItem from "./ExamListItem";
    import examApi from "../data/ExamApi";

    export default {
        name: "ExamList",
        components: {ExamListItem},

        data() {
            return {
                exams: [],

                error: null,
                fieldsErrors: [],
                loading: false,
            }
        },
        mounted() {
            examApi.fetchExams()
                .then(response => {
                    this.exams = response
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },

        methods: {

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },

            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    }
</script>

<style src="@/assets/hometeacher/css/main.css">
</style>


<style scoped>

    .alert {
        font-size: 18px;
        font-family: "Manrope Bold";
    }

    body {
        font-family: Manrope Light;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: #000000;
        text-align: left;
    }

    p {
        color: #000000;
        font-weight: 400;
        line-height: 1.5;
    }

    .OnlineTeacher {
        background-color: white !important;
    }


</style>
